import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { LoggedInService } from '../auth/loggedin.service';

@Injectable({
  providedIn: 'root'
})
export class HandleErrorService {

  constructor(private loggedinService: LoggedInService) { }

  handleError(error: HttpErrorResponse): Observable<never> {
    if(error.status === 401 || error.status === 403) {
      this.loggedinService.redirectToPing()
    }
    const err = new Error(error.message);
    return throwError(() => err);
  }

  handleErrorWithoutRedirectToPing(error: HttpErrorResponse): Observable<never> {
    const err = new Error(error.message);
    return throwError(() => err);
  }

}
